import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';  // Using useNavigate
import { doc, getDoc, updateDoc } from 'firebase/firestore'; // Using db from firebase
import { auth, db } from '../firebase';  // Import db correctly
import { AuthContext } from '../context/AuthProvider'; // Assuming you have this context

const Profile = () => {
  const { user } = useContext(AuthContext);
  const [profileData, setProfileData] = useState(null);
  const [newBio, setNewBio] = useState('');
  const navigate = useNavigate(); // Using useNavigate instead of useHistory

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirect to login if user is not authenticated
      return;
    }

    const fetchProfile = async () => {
      const userRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        setProfileData(userDoc.data());
        setNewBio(userDoc.data().bio || ''); // Assuming the bio field exists
      } else {
        console.log('No such user document!');
      }
    };

    fetchProfile();
  }, [user, navigate]);  // Make sure navigate is included as a dependency

  const handleBioChange = async () => {
    if (!newBio) return; // Avoid empty bio update
    const userRef = doc(db, 'users', user.uid);
    await updateDoc(userRef, { bio: newBio });
    setProfileData((prevState) => ({ ...prevState, bio: newBio }));
  };

  if (!profileData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-column align-items-center">
            <div className="profile-picture bg-secondary rounded-circle mb-3"></div>
            <h3 className="username">{profileData.username}</h3>
            <p className="fullname">{profileData.fullName}</p>
            <div className="bio text-center">
              <input
                type="text"
                value={newBio}
                onChange={(e) => setNewBio(e.target.value)}
                placeholder="Update Bio"
              />
              <button onClick={handleBioChange}>Update Bio</button>
            </div>
          </div>
        </div>
      </div>
      {/* Add your followers, following, and posts section here */}
    </div>
  );
};

export default Profile;
